module.exports = __webpack_public_path__ + "static/media/italian-leather.1408c7a8.jpg";